// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"_1EBXz","panel":"WG8My","hideInfo":"_1Zo8K","detailsTitle":"_3NHiB","detailsText":"_2I2qf"};